import React from "react";
import { _t } from "app/i18n/i18n";
import { postPreferences } from "pages/preferences/api/postPrefrences";
import { Preferences } from "pages/preferences/Preferences";
import { Button, Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { miscSlice } from "redux/slices/miscSlice";
import ErrorBoundary from "lib/ErrorBoundary";

export const PreferencesDialog = () => {
  const preferences = useSelector((state) => state.preferences);
  const show = useSelector((state) => state.misc.showPreferencesDialog);
  const dispatch = useDispatch();
  const showPreferencesDialog = (isVisible) =>
    dispatch(miscSlice.actions.set({ key: "showPreferencesDialog", value: isVisible }));

  return (
    <ErrorBoundary>
      <Modal show={show} onHide={() => showPreferencesDialog(false)} size="lg" scrollable={true}>
        <Modal.Header className="bg-dark">
          <Modal.Title>
            <h3 className="font-weight-lighter text-white">{_t("Preferences")}</h3>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="bg-dark">
          <Preferences />
        </Modal.Body>

        <Modal.Footer className="bg-dark">
          <Button variant="secondary" onClick={() => showPreferencesDialog(false)}>
            {_t("Close")}
          </Button>
          <Button variant="primary" onClick={() => postPreferences(preferences) && showPreferencesDialog(false)}>
            {_t("Save")}
          </Button>
        </Modal.Footer>
      </Modal>
    </ErrorBoundary>
  );
};
